import { render, staticRenderFns } from "./PointClouds.vue?vue&type=template&id=1e8fb7d6&scoped=true"
import script from "./PointClouds.vue?vue&type=script&lang=js"
export * from "./PointClouds.vue?vue&type=script&lang=js"
import style0 from "./PointClouds.vue?vue&type=style&index=0&id=1e8fb7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8fb7d6",
  null
  
)

export default component.exports